import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "@/components/ui/dropdown";
import { AppSubscriptionStatus } from "@/gql/__generated__/graphql";
import { Ellipsis } from "lucide-react";
import { useState } from "react";
import {
  SubscriptionTable,
  isInboundSubscription,
  isOutboundSubscription
} from "../../types/subscriptions.type";
import { CancelInboundSubscriptionDialog } from "./CancelSubscription/CancelInboundSubscriptionDialog";
import { WithdrawOutboundSubscriptionDialog } from "./CancelSubscription/WithdrawOutboundSubscription";

interface Props {
  subscription: SubscriptionTable;
}

export const SubscriptionActions = ({ subscription }: Props) => {
  const [cancelSubscriptionOpen, setCancelSubscriptionOpen] = useState(false);

  let options: JSX.Element[] = [];

  if (subscription.status === AppSubscriptionStatus.Active) {
    options.push(
      <DropdownMenuItem
        className="text-brand-error"
        onClick={() => setCancelSubscriptionOpen(true)}
      >
        {isInboundSubscription(subscription)
          ? "Cancel subscription"
          : "Withdraw subscription"}
      </DropdownMenuItem>
    );
  }

  if (options.length <= 0) return null;
  return (
    <div className="flex justify-end pr-2" data-testid="action-cell">
      {isInboundSubscription(subscription) && (
        <CancelInboundSubscriptionDialog
          subscription={subscription}
          open={cancelSubscriptionOpen}
          setOpen={setCancelSubscriptionOpen}
        />
      )}
      {isOutboundSubscription(subscription) && (
        <WithdrawOutboundSubscriptionDialog
          subscription={subscription}
          open={cancelSubscriptionOpen}
          setOpen={setCancelSubscriptionOpen}
        />
      )}

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className="h-8 w-8 p-0">
            <span className="sr-only">Open menu</span>
            <Ellipsis className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">{...options}</DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
